import { Gateway } from '../../types/gateway'

export const siteKeyGatewayOptions = (ids: string[], gateways?: Gateway[]) => {
  const byId = new Map(
    gateways?.map((gateway) => [gateway.basicDetails.gatewayId, gateway]) || []
  )

  return ids.flatMap((id) => {
    const gateway = byId.get(id)
    return gateway ? [{ value: id, label: gateway.basicDetails.name }] : []
  })
}
